class configTable {
  constructor(operId, nameTable, columns) {
    this.operId = operId;
    this.nameTable = nameTable;
    this.columns = columns;
  }
  static fromJson({ operId, tabla, jsonData }) {
    return new configTable(operId, tabla, jsonData);
  }
}

export default configTable;
